<div *ngIf="warehouseLocation">
  <div class="">
    <div *ngIf="warehouseLocation.warehouseLocation_ID" class="card-header">
      <h3 i18n>Edit Warehouse Location</h3>
      <p i18n>Make the necessary changes on the form below then click Submit</p>
    </div>

    <div *ngIf="!warehouseLocation.warehouseLocation_ID">
      <div class="">
        <h3 i18n>Add Warehouse Location</h3>
        <p i18n>To add a new Warehouse Location, complete the form below then click Submit.</p>
      </div>
    </div>
    <div class="">
      <form #form="ngForm" (ngSubmit)="saveWarehouseLocation(form)">
        <div class="form-group row">
          <label for="name" i18n>Name</label>
          <input id="name" name="name" class="form-control" [(ngModel)]="warehouseLocation.warehouseLocation_Name"
                 required #name="ngModel"
                 [class.field-error]="form.submitted && name.invalid">
          <div [hidden]="!form.submitted || name.valid"
               class="alert alert-danger" i18n>Name is invalid</div>
        </div>
        <div class="form-group row">
          <label for="locationRow" i18n>Row</label>
          <input type="number" id="locationRow" name="locationRow" class="form-control" [(ngModel)]="warehouseLocation.warehouseLocation_Row"
                 required #locationRow="ngModel"
                 [class.field-error]="form.submitted && locationRow.invalid">
          <div [hidden]="!form.submitted || locationRow.valid"
               class="alert alert-danger" i18n>Row is invalid</div>
        </div>
        <div class="form-group row">
          <label for="locationShelf" i18n>Shelf</label>
          <input type="number" id="locationShelf" name="locationShelf" class="form-control" [(ngModel)]="warehouseLocation.warehouseLocation_Shelf"
                 required #locationShelf="ngModel"
                 [class.field-error]="form.submitted && locationShelf.invalid">
          <div [hidden]="!form.submitted || locationShelf.valid"
               class="alert alert-danger" i18n>Shelf is invalid</div>
        </div>
        <div class="form-group row">
          <label for="locationBin" i18n>Bin</label>
          <input type="number" id="locationBin" name="locationBin" class="form-control" [(ngModel)]="warehouseLocation.warehouseLocation_Bin"
                 required #locationBin="ngModel"
                 [class.field-error]="form.submitted && locationBin.invalid">
          <div [hidden]="!form.submitted || locationBin.valid"
               class="alert alert-danger" i18n>Bin is invalid</div>
        </div>
        <div class="form-group row">
          <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="isActive" name="isActive" [(ngModel)]="warehouseLocation.warehouseLocation_IsActive" #isActive="ngModel" />
            <label class="custom-control-label" for="isActive" i18n>Is Active</label>
          </div>
        </div>

        <div [hidden]="!postError"
             class="alert alert-danger">

          <!--{{ postErrorMessage }}-->
        </div>

        <div class="row">

          <div class="col-md-12">
            <div align="right" class="mb-3">
              <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
              <a routerLink="/admin/list/warehouse" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
